import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getUser } from 'src/app/store/selectors/auth.selectors';

@Component({
  selector: 'app-listing',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="page-listing">
      <header-menu></header-menu>
      <search-container *ngIf="(user$ | async)?.typeBusiness === 'company'"></search-container>
      <component-filters *ngIf="(user$ | async)?.typeBusiness !== 'company'"></component-filters>
    </div>
  `
})

export class ListingPageComponent {

  user$;

  constructor(
    private store: Store
  ) {
    this.user$ = this.store.pipe(select(getUser));
  }
}
